<template>
  <TemplateLidBase>
    <main class="relative z-0 col-span-full row-start-2">
      <!-- Header -->
      <MoleculeLidHeaderOverview
        class="mb-8 md:mb-12 xl:mb-16"
        :title="page.title"
        :subtitle="page.subtitle"
        :introduction="page.introduction"
        :image="page.image"
        :class="{ 'mt-12 md:mt-16 lg:mt-20': !page.image }"
      />

      <OrganismLidNavigationBreadcrumb
        :dark-mode-mobile="!!page.image"
        class="absolute z-30 top-0 mx-4 lg:mx-6 xl:mx-12 mb-6"
        :path="breadcrumbs"
        :class="{ 'md:relative p-4 md:p-0': page.image, 'md:mt-3 lg:mt-4': !page.image }"
      />

      <!-- Overview section with cards -->
      <section class="mx-4 lg:mx-6 xl:mx-12 mb-24 xl:mb-40">
        <ul class="flex flex-col gap-12 lg:gap-2 xl:gap-24">
          <li v-for="(item, index) in page.items" :key="index">
            <h2 class="font-black text-xl sm:text-2xl lg:text-3xl xl:text-5xl 2xl:text-6xl leading-none mb-5 md:mb-6 lg:mb-8 xl:mb-10">{{ item.label }}</h2>
            <ul class="grid grid-cols-1 sm:grid-cols-12 gap-y-16 gap-x-8 xl:gap-x-12 xl:gap-y-24">
              <li v-for="(child, childIndex) in item.children" :key="childIndex" class="col-span-full sm:col-span-6 lg:col-span-4 xl:col-span-3">
                <MoleculeCarouselLidCarouselSlideStory
                  :read-more="false"
                  :url="child.url"
                  :title="child.title"
                  :image="child.image"
                  class="col-span-full sm:col-span-6 lg:col-span-4"
                />
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </main>
  </TemplateLidBase>
</template>

<script setup lang="ts">
interface Props {
  breadcrumbs?: Array<any>
  page: {
    title: string
    subtitle: string
    introduction: string
    image: string | null
    items: Array<{
      label: string
      children: Array<{
        url: string
        title: string
        image: string
      }>
    }>
  }
}

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
})
</script>
